import React, { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Link } from 'react-router-dom';
import ApiCall from "../../utils/Api"
import { toast } from 'react-toastify';
import Web3 from "web3";
import contractABI from '../../utils/contractABI';

export default function SalesTable({transetionDetails,filterState}) {
  const contractAddress = import.meta.env.VITE_APP_contractAddress; // Replace with your contract address
  const TDUcontractAddress=import.meta.env.VITE_APP_TDUcontractAddress
    const [isconnected, setisconnected] = useState(false);
  const [rows, setRows] = useState([]);
  const [web3, setWeb3] = useState(null);
  const [contract, setContract] = useState(null);
  const initWeb3 = async () => {
    if (window.ethereum) {
      // Modern dapp browsers
      const web3Instance = new Web3(window.ethereum);
      try {
        // Request user approval to access their accounts
        await window.ethereum.enable();
        setWeb3(web3Instance);
        setisconnected(true);
        localStorage.setItem("web3Instance", JSON.stringify(web3Instance)); // Save web3 instance to local storage
      } catch (error) {
        // if (error?.response?.data?.message) {
        //            toast.error(error.response.data.message);
        //          } else {
        //            toast.error(error.message);
        //          }
        console.error(error);
      }
    } else if (window.web3) {
      // Legacy dapp browsers
      const web3Instance = new Web3(window.web3.currentProvider);
      setWeb3(web3Instance);
    } else {
      // Non-dapp browsers
      console.log("Please install MetaMask!");
    }
  };
  useEffect(() => {
    initWeb3();
  }, []);
  useEffect(() => {
    const initContract = async () => {
      try {
        const deployedContract = new web3.eth.Contract(
          contractABI,
          contractAddress
        );
        setContract(deployedContract);

        // localStorage.setItem(
        //   "deployedContract",
        //   JSON.stringify(deployedContract)
        // ); // Save web3 instance to local storage
      } catch (error) {
        console.log(error);
      }
    };

    if (web3) {
      initContract();
    }
  }, [web3]);
  function formatEtherFromWei(weiValue, decimalPlaces) {
    // Convert wei to ether using Web3.js utility function
    const etherValue = web3.utils.fromWei(weiValue, "ether");

    // Limit the ether value to a specified number of decimal places
    const formattedEther = parseFloat(etherValue).toFixed(decimalPlaces);

    // Return the formatted ether value with "ETH" appended
    return formattedEther + " ETH";
}
  return (
   <> <TableContainer style={{borderRadius:9}} component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead style={{backgroundColor:"Black"}}>
          <TableRow>
            <TableCell align="center" style={{color:"white"}}>Provider</TableCell>
            <TableCell align="center" style={{color:"white"}}>Select Period</TableCell>
            {/* <TableCell align="center" style={{color:"white"}}>Select Period</TableCell> */}
            {/* <TableCell align="center" style={{color:"white"}}>Total Transactions</TableCell> */}
            <TableCell align="center" style={{color:"white"}}>Units Created</TableCell>
            <TableCell align="center" style={{color:"white"}}>Units Sold</TableCell>
            {/* <TableCell align="center" style={{color:"white"}}>Net Sales in TDU</TableCell> */}
            <TableCell align="center" style={{color:"white"}}>Gross Sales in ETH</TableCell>
            <TableCell align="center" style={{color:"white"}}>Code</TableCell>
            <TableCell align="center" style={{color:"white"}}>Net Sales in ETH</TableCell>
            <TableCell align="center" style={{color:"white"}}>Provider %</TableCell>
            <TableCell align="center" style={{color:"white"}}>Cuneus %</TableCell>
            <TableCell align="center" style={{color:"white"}}>Provider Sales</TableCell>
            <TableCell align="center" style={{color:"white"}}>Links</TableCell>
            {/* <TableCell align="right">Carbs&nbsp;(g)</TableCell>
            <TableCell align="right">Protein&nbsp;(g)</TableCell> */}
          </TableRow>
        </TableHead>
        <TableBody>
          {transetionDetails.map((row) => (
            <TableRow
              key={row.name}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell align="center">
                {row.providerName}
              </TableCell>
              <TableCell align="center">
                {filterState}
              </TableCell>
              {/* <TableCell align="center">{row.code}</TableCell> */}
              {/* <TableCell align="center"> {row.totalTransactions}</TableCell> */}
              <TableCell align="center"> {row.totalUnitsCreated}</TableCell>
              <TableCell align="center"> {row.totalUnitsSold}</TableCell>
              <TableCell align="center"> {formatEtherFromWei(row.totalGrossAmount,6)}</TableCell>
              <TableCell align="center"> {row.institutionCode}</TableCell>
              <TableCell align="center" ><div>{`(P) ${formatEtherFromWei(row.totalProviderSplitAmount,6)}`}</div> <div>{`(C) ${formatEtherFromWei(row.totalOwnerSplitAmount,6)}`}</div> </TableCell>
              <TableCell align="center"> {row.ProviderSplit}</TableCell>
              <TableCell align="center"> {row.ownerSplit}</TableCell>
              <TableCell align="center"><Link to={`/admin-panel/SalesBalance`}>Graph</Link></TableCell>
              <TableCell align="center"><Link to={`/admin-panel/Sales/TransactionDetails/${row.providerId}`}>View Detail</Link></TableCell>

            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    </>
  );
}